module.exports = __webpack_public_path__ + "static/img/1.44c6cc6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/1.png
// module id = Ortn
// module chunks = 0